import { useLocationTracking } from '../hooks/useLocationTracking';

const LocationTracker = () => {
  useLocationTracking();
  return null;
};

export default LocationTracker;
